import { Avatar, Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useIsDesktop } from 'Hooks';
import { PurpleAlert } from 'Images';

export const ExtraEntitlementsPrevYearAlert = () => {
  const isDesktop = useIsDesktop();
  return (
    <Stack
      direction='row'
      alignItems={isDesktop ? 'center' : 'flex-start'}
      gap='8px'
      sx={{
        width: 'fit-content',
        p: isDesktop ? '12px' : '12px 48px 12px 12px',
        bgcolor: '#E7EDFF',
        borderRadius: '12px',
        border: '1px solid #E7EDFF',
      }}
    >
      <Avatar
        alt=''
        src={PurpleAlert}
        sx={{
          width: '24px',
          height: '24px',
          mt: isDesktop ? undefined : '2px',
        }}
      />
      <Typography variant='body3'>
        {Dictionary[DICTIONARY.Treatment].extraEntitlementsDaysPrevYear}
      </Typography>
    </Stack>
  );
};
